export const sliceName = 'institutionDivisions'

export const FACETS_NAMES = { 1: 'faculty', 2: 'branch', 3: 'otherAffiliatedStructures' }
